export default {"src":"/_next/static/media/stressMotivationMobile.2b467ac8.svg","height":232,"width":272,"blurWidth":0,"blurHeight":0};